import syndroms from './syndroms.json';

export const data = {
    syndroms: syndroms,
};